import { render, staticRenderFns } from "./DocumentNewFrGroup.vue?vue&type=template&id=76b0c8f5&"
import script from "./DocumentNewFrGroup.vue?vue&type=script&lang=js&"
export * from "./DocumentNewFrGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports